import states from './stateList.json';

const getStateList = () => states.map(s => ({ label: s.label, name: s.name, value: s.value }));

export default getStateList();
